import { Component } from 'react';
import { RadioBox } from './radiobox';
import { FormError } from './form-errors';
import { MontantInput } from './montant-input';
import { MontantsDetailles } from './details-montant-input';
import analytics, { FIELD_IDS, CONDITIONAL_IDS } from '../../services/analytics';

const STEP_NUMBER = 6;

class Questionnaire extends Component {
	constructor(props) {
		super(props);

		// Récupérer le field tracker pour le tracking granulaire des champs
		this.fieldTracker = analytics.getFieldTracker();
		// Determine steps based on whether reduction eligibility questions were shown in logement.js
		// reductionEligibilitySelection indicates if the user made a selection (oui, non, or later), but
		// we need to check if the questions were actually displayed in the first place
		const reductionEligibilityData = props.menage?.reductionEligibilityData || null;
		const reductionEligibilitySelection = props.reductionEligibilitySelection || null;
		let dynamicSteps = 5; // Base steps

		// Add contact info (step 6) if reduction eligibility questions were shown and user made a selection that requires contact info
		if (reductionEligibilityData && reductionEligibilitySelection !== 'no') {
			dynamicSteps = 6;
		}
		// If no reduction eligibility data exists (questions weren't shown), or selection was 'no', keep base steps (5 steps)

		this.state = {
			steps: dynamicSteps - 1, // Reduced by 1 since we're removing lieuxSolidaire step
			step: 1,
			hasPensionAlimentaire: false,
			pensionAlimentaire: {
				value: {},

			},
			pensionDetails: false,
			permisDeConduire: false,
			lieuxSolidaire: false,
			creationEntreprise: false,
			aideAchatVelo: false,
			errors: [],
			rfr: 0,
			// Contact information fields for the new 5th step (originally 6th)
			lastName: '',
			firstName: '',
			email: '',
			phoneNumber: '',
			// Store reduction eligibility selection to check for conditional display
			reductionEligibilitySelection: reductionEligibilitySelection,
		};

		/* Initialisation pension alimentaire */

		this.state.pensionAlimentaire.value = '';
		/*aides velo */

		this.state.veloPrice = 0;
		this.state.veloType = false;


	}


	updateVeloPrice = (event) => {
		// Field tracking
		this.fieldTracker.onFieldChange(STEP_NUMBER, FIELD_IDS.STEP_FINAL_QUESTIONS.prix_velo, event.target.value);
		this.setState({ veloPrice: event.target.value });
	}

	updateVeloType = (event) => {
		// Field tracking
		this.fieldTracker.onFieldFocus(STEP_NUMBER, FIELD_IDS.STEP_FINAL_QUESTIONS.type_velo, this.state.veloType);
		this.fieldTracker.onFieldChange(STEP_NUMBER, FIELD_IDS.STEP_FINAL_QUESTIONS.type_velo, event.target.value);
		this.fieldTracker.onFieldBlur(STEP_NUMBER, FIELD_IDS.STEP_FINAL_QUESTIONS.type_velo, event.target.value);
		this.setState({ veloType: event.target.value });
	}
	updateRFR = (event) => {
		this.setState({ rfr: event.target.value });

	}

	// Format phone number to French format
	formatPhoneNumber = (value) => {
		// Remove all non-digit characters
		const phoneNumber = value.replace(/\D/g, '');

		// If empty, return empty string
		if (!phoneNumber) return '';

		// If length is more than 9, truncate to 9 digits
		const truncated = phoneNumber.substring(0, 10);

		// Format as XX XX XX XX XX
		let formatted = '';
		for (let i = 0; i < truncated.length; i++) {
			if (i > 0 && i % 2 === 0) {
				formatted += ' ';
			}
			formatted += truncated[i];
		}

		return formatted;
	}

	// Handler for contact information input fields
	handleChangeContact = (e) => {
		const { name, value } = e.target;

		// Field tracking - map name to FIELD_IDS
		const fieldIdMap = {
			'lastName': FIELD_IDS.STEP_FINAL_QUESTIONS.contact_nom,
			'firstName': FIELD_IDS.STEP_FINAL_QUESTIONS.contact_prenom,
			'email': FIELD_IDS.STEP_FINAL_QUESTIONS.contact_email,
			'phoneNumber': FIELD_IDS.STEP_FINAL_QUESTIONS.contact_telephone,
		};
		const fieldId = fieldIdMap[name] || `FIELD_CONTACT_${name.toUpperCase()}`;
		this.fieldTracker.onFieldChange(STEP_NUMBER, fieldId, value);

		// Special handling for phone number
		if (name === 'phoneNumber') {
			const formattedValue = this.formatPhoneNumber(value);
			this.setState({ phoneNumber: formattedValue });
		} else {
			this.setState({ [name]: value });
		}
	}

	checkInputErrors = async () => {
		const STEP_NUMBER = 6;
		let errors = []
		if (this.state.step === 1
			&& (isNaN(this.state.pensionAlimentaire.value) || this.state.pensionAlimentaire.value === "")
			&& this.state.hasPensionAlimentaire
			&& !this.state.pensionDetails
		) {
			errors.push("Veuillez saisir un montant valide pour la pension alimentaire.");
			analytics.trackValidationError(STEP_NUMBER, 'ALIMONY_AMOUNT_REQUIRED', 'pensionAlimentaire');
		}
		// Add validation for contact information fields on step 5 (only if reduction eligibility was 'oui' or 'later')
		if (this.state.step === 5 && (this.state.reductionEligibilitySelection === 'oui' || this.state.reductionEligibilitySelection === 'later')) {
			if (!this.state.lastName.trim()) {
				errors.push("Veuillez saisir votre nom.");
				analytics.trackValidationError(STEP_NUMBER, 'LASTNAME_REQUIRED', 'lastName');
			}
			if (!this.state.firstName.trim()) {
				errors.push("Veuillez saisir votre prénom.");
				analytics.trackValidationError(STEP_NUMBER, 'FIRSTNAME_REQUIRED', 'firstName');
			}
			if (!this.state.email.trim()) {
				errors.push("Veuillez saisir votre email.");
				analytics.trackValidationError(STEP_NUMBER, 'EMAIL_REQUIRED', 'email');
			} else if (!/\S+@\S+\.\S+/.test(this.state.email)) {
				errors.push("Veuillez saisir une adresse email valide.");
				analytics.trackValidationError(STEP_NUMBER, 'EMAIL_FORMAT', 'email');
			}
			if (!this.state.phoneNumber.trim()) {
				errors.push("Veuillez saisir votre numéro de téléphone.");
				analytics.trackValidationError(STEP_NUMBER, 'PHONE_REQUIRED', 'phoneNumber');
			} else {
				// Remove spaces for validation
				const cleanPhoneNumber = this.state.phoneNumber.replace(/\s/g, '');
				if (cleanPhoneNumber.length !== 10) {
					errors.push("Veuillez saisir un numéro de téléphone valide (10 chiffres).");
					analytics.trackValidationError(STEP_NUMBER, 'PHONE_FORMAT', 'phoneNumber');
				}
			}
		}

		this.setState({ errors: errors });
	}

	nextStep = (e) => {
		if (this.state.errors.length > 0) {
			return false;
		}
		let anchor = document.getElementById('anchor');
		const yOffset = -80;
		const y = anchor.getBoundingClientRect().top + window.pageYOffset + yOffset;
		window.scrollTo({ top: y, behavior: 'smooth' });

		// Check if we need to skip step 6 (contact info) based on the same conditions as getQuestion
		const shouldShowContactInfo = this.props.menage?.reductionEligibilityData && this.state.reductionEligibilitySelection !== 'no';

		// If we're currently on step 5 and we shouldn't show contact info, jump directly to final step
		if (this.state.step === 5 && !shouldShowContactInfo) {
			// Bypass step 6 and go directly to validation
			var data = {
				"demandeur": {
					//permis
					permis_de_conduire: this.state.permisDeConduire,
					//lieux solidaire
					afficherLieuxSolidaire: this.state.lieuxSolidaire,
					//creation Entreprise
					creationEntreprise: this.state.creationEntreprise,
					typeVelo: this.state.veloType,
					prixVelo: this.state.veloPrice,
					rfrParPart: this.state.rfr,
				},
				"terminer": true,
			};

			if (this.state.hasPensionAlimentaire) {

				if (this.state.pensionDetails === false) {
					data.demandeur.pensions_alimentaires_versees_individu = {};
					let curMonth = new Date().getMonth();
					let curYear = new Date().getFullYear();

					let tarYear = curYear - 1;
					while (curYear >= tarYear) {
						let curDate = curYear + '-' + ('0' + (curMonth + 1)).slice(-2);
						data.demandeur.pensions_alimentaires_versees_individu[curDate] = this.state.pensionAlimentaire.value;
						curMonth -= 1;

						if (curMonth < 0) {
							curMonth = 11;
							curYear -= 1;
						}
					}

				} else {
					data.demandeur.pensions_alimentaires_versees_individu = this.state.pensionAlimentaire.value;
				}
			}

			//data.demandeur.velo = { price : this.state.veloPrice , type : this.state.veloType }
			data.demandeur.typeVelo = this.state.veloType;
			data.demandeur.prixVelo = this.state.veloPrice;

			// Add contact information to the right place for resultat.js to access
			if (this.state.lastName || this.state.firstName || this.state.email || this.state.phoneNumber) {
				// Ensure data.menage exists before setting reductionEligibilityData
				if (!data.menage) {
					data.menage = {};
				}
				// Preserve any existing reductionEligibilityData from previous steps and extend with contact info
				// This ensures meeting information set in logement.js is preserved
				const existingReductionData = this.props.menage?.reductionEligibilityData || {};
				// This should match the format expected by resultat.js papernestData
				data.menage.reductionEligibilityData = {
					...existingReductionData, // Preserve existing data (including meeting info)
					firstName: this.state.firstName,
					lastName: this.state.lastName,
					email: this.state.email,
					phoneNumber: this.state.phoneNumber.replace(/\s/g, ''), // Remove spaces before saving
					selectedOption: this.state.reductionEligibilitySelection // Pass the original selection
				};
			}

			this.props.validateStep(data);
		} else if (this.state.step + 1 > this.state.steps) {
			// Original behavior: process step 6 and go to final validation
			var data = {
				"demandeur": {
					//permis
					permis_de_conduire: this.state.permisDeConduire,
					//lieux solidaire
					afficherLieuxSolidaire: this.state.lieuxSolidaire,
					//creation Entreprise
					creationEntreprise: this.state.creationEntreprise,
					typeVelo: this.state.veloType,
					prixVelo: this.state.veloPrice,
					rfrParPart: this.state.rfr,
				},
				"terminer": true,
			};

			if (this.state.hasPensionAlimentaire) {

				if (this.state.pensionDetails === false) {
					data.demandeur.pensions_alimentaires_versees_individu = {};
					let curMonth = new Date().getMonth();
					let curYear = new Date().getFullYear();

					let tarYear = curYear - 1;
					while (curYear >= tarYear) {
						let curDate = curYear + '-' + ('0' + (curMonth + 1)).slice(-2);
						data.demandeur.pensions_alimentaires_versees_individu[curDate] = this.state.pensionAlimentaire.value;
						curMonth -= 1;

						if (curMonth < 0) {
							curMonth = 11;
							curYear -= 1;
						}
					}

				} else {
					data.demandeur.pensions_alimentaires_versees_individu = this.state.pensionAlimentaire.value;
				}
			}

			//data.demandeur.velo = { price : this.state.veloPrice , type : this.state.veloType }
			data.demandeur.typeVelo = this.state.veloType;
			data.demandeur.prixVelo = this.state.veloPrice;

			// Add contact information to the right place for resultat.js to access
			if (this.state.lastName || this.state.firstName || this.state.email || this.state.phoneNumber) {
				// Ensure data.menage exists before setting reductionEligibilityData
				if (!data.menage) {
					data.menage = {};
				}
				// Preserve any existing reductionEligibilityData from previous steps and extend with contact info
				// This ensures meeting information set in logement.js is preserved
				const existingReductionData = this.props.menage?.reductionEligibilityData || {};
				// This should match the format expected by resultat.js papernestData
				data.menage.reductionEligibilityData = {
					...existingReductionData, // Preserve existing data (including meeting info)
					firstName: this.state.firstName,
					lastName: this.state.lastName,
					email: this.state.email,
					phoneNumber: this.state.phoneNumber.replace(/\s/g, ''), // Remove spaces before saving
					selectedOption: this.state.reductionEligibilitySelection // Pass the original selection
				};
			}

			this.props.validateStep(data);
		}


		this.setState(({ step }) => {
			// If we're on step 5 and shouldn't show contact info, skip to the next step which should jump to validation
			if (step === 5 && !shouldShowContactInfo) {
				return { step: step + 2 }; // Skip step 6 to go directly to validation
			}
			return { step: step + 1 };
		});
	}

	switchRadio = (newValue, modelName) => {
		// Field tracking - map modelName to FIELD_IDS
		const fieldIdMap = {
			'hasPensionAlimentaire': FIELD_IDS.STEP_FINAL_QUESTIONS.pension_alimentaire,
			'permisDeConduire': FIELD_IDS.STEP_FINAL_QUESTIONS.aide_permis,
			'creationEntreprise': FIELD_IDS.STEP_FINAL_QUESTIONS.creation_entreprise,
			'aideAchatVelo': FIELD_IDS.STEP_FINAL_QUESTIONS.aide_velo,
		};
		const fieldId = fieldIdMap[modelName] || `FIELD_${modelName.toUpperCase()}`;
		this.fieldTracker.onFieldFocus(STEP_NUMBER, fieldId, this.state[modelName]);
		this.fieldTracker.onFieldChange(STEP_NUMBER, fieldId, newValue);
		this.fieldTracker.onFieldBlur(STEP_NUMBER, fieldId, newValue);

		// Track conditional sections
		if (modelName === 'hasPensionAlimentaire' && (newValue === true || newValue === 'true')) {
			analytics.trackConditionalShown(STEP_NUMBER, CONDITIONAL_IDS.ALIMONY_AMOUNT, 'hasPensionAlimentaire');
		}
		if (modelName === 'aideAchatVelo' && (newValue === true || newValue === 'true')) {
			analytics.trackConditionalShown(STEP_NUMBER, CONDITIONAL_IDS.BIKE_DETAILS, 'aideAchatVelo');
		}

		newValue = JSON.parse(newValue);
		this.setState(() => {
			var newState = new Object({});
			newState[modelName] = newValue;
			return newState;
		});
	}

	switchDetails = (e) => (this.setState(({ pensionDetails }) => {
		pensionDetails = !pensionDetails;
		return { pensionDetails: pensionDetails }
	}))

	capturePensionAlimentaire = (montant) => {
		this.setState(({ pensionAlimentaire }) => {
			pensionAlimentaire.value = montant;
			return { pensionAlimentaire: pensionAlimentaire };
		});
	}

	capturePensionDetailler = (montants) => {
		this.setState(({ pensionAlimentaire, pensionDetails }) => {
			pensionAlimentaire.value = montants;
			pensionDetails = true;
			return { pensionAlimentaire: pensionAlimentaire };
		});
	}
	//
	pensionAlimentaire = () => {
		return <div className="pension-alimentaire">
			<div className="left-side">
				<RadioBox name="pensionAlimentaire"
					options={{ "Oui": true, "Non": false }}
					handler={this.switchRadio}
					modelName="hasPensionAlimentaire"
					defaultValue={this.state.hasPensionAlimentaire}

				><h3>Vous ou votre conjoint·e actuel·le avez-vous versé des pensions alimentaires depuis décembre 2021 ?</h3></RadioBox>
			</div>
			<div className="right-side zone-pa">
				{(this.state.hasPensionAlimentaire) ?
					<div className="saisi-montant">
						<div className="ressource-label">Pensions alimentaires</div>
						{(!this.state.pensionDetails) ?
							<MontantInput name="pensionAlimentaire"
								model={this.state.pensionAlimentaire.value}
								modelName="pensionAlimentaire"
								handler={this.capturePensionAlimentaire}
							>Montant versé chaque mois</MontantInput>
							: <MontantsDetailles name="pensionAlimentaire"
								handler={this.capturePensionDetailler}
							></MontantsDetailles>
						}
						<small className="detail-button"
							onClick={this.switchDetails}
						>
							{(this.state.pensionDetails) ?
								'Montant fixe perçu chaque mois'
								: 'détaillez les montants sur les 12 derniers mois'}
						</small>
					</div>
					: ""
				}
			</div>
		</div>;
	}

	permisDeConduire = () => {
		return <div className="question">
			<RadioBox
				name="permisDeConduire"
				options={{ "Oui": true, "Non": false }}
				defaultValue={this.state.permisDeConduire}
				modelName="permisDeConduire"
				handler={this.switchRadio}
			><h3>Souhaitez-vous connaître les aides financières au permis de conduire ?</h3></RadioBox>
		</div>;
	}

	previous = () => {
		this.props.previousStep();
	}

	restart = () => {
		this.props.restart();
	}

	creationEntreprise = () => {
		return <div className="question">
			<RadioBox
				name="creationEntreprise"
				options={{ "Oui": true, "Non": false }}
				defaultValue={this.state.creationEntreprise}
				modelName="creationEntreprise"
				handler={this.switchRadio}
			><h3>Souhaitez-vous créer ou reprendre une entreprise ?</h3></RadioBox>
		</div>;
	}

	aideAchatVelo = () => {


		return <div className="question">
			<RadioBox
				name="aideAchatVelo"
				options={{ "Oui": true, "Non": false }}
				defaultValue={this.state.aideAchatVelo}
				modelName="aideAchatVelo"
				handler={this.switchRadio}
			><h3>Souhaitez-vous connaître les aides financières pour l'achat d'un velo ?</h3></RadioBox>
			<div className={this.state.aideAchatVelo ? "visible" : "hidden"}>

				<div className="question sub-question">
					<h3>Prix du vélo</h3>
					<div className="input-with-euro">
						<input type="number" placeholder="Prix du vélo en euros" onChange={this.updateVeloPrice} />
						<span className="euroSign">€</span>
					</div>
				</div>

				<div className="question sub-question">
					<h3>Type de vélo</h3>
					<select onChange={this.updateVeloType} >
						<option value="">Choisir le type de vélo</option>
						<option value="électrique">Electrique</option>
						<option value="mécanique simple">Mécanique simple</option>
						<option value="cargo" >Cargo</option>
						<option value="cargo électrique" >Cargo Electrique</option>
						<option value="pliant" >Pliant</option>
						<option value="pliant électrique" >Pliant electrique</option>
					</select>
				</div>
			</div>
		</div>;
	}
	//
	contactInfo = () => {
		return <div className="question">
			<h3>Informations de contact</h3>
			<div className="contact-form">
				<div className="form-group">
					<input
						type="text"
						id="lastName"
						name="lastName"
						value={this.state.lastName}
						onChange={this.handleChangeContact}
						placeholder="Nom"
					/>
				</div>

				<div className="form-group">
					<input
						type="text"
						id="firstName"
						name="firstName"
						value={this.state.firstName}
						onChange={this.handleChangeContact}
						placeholder="Prénom"
					/>
				</div>

				<div className="form-group">
					<input
						type="email"
						id="email"
						name="email"
						value={this.state.email}
						onChange={this.handleChangeContact}
						placeholder="Email"
					/>
				</div>

				<div className="form-group">
					<input
						type="tel"
						id="phoneNumber"
						name="phoneNumber"
						value={this.state.phoneNumber}
						onChange={this.handleChangeContact}
						placeholder="Téléphone mobile (Format: 06 12 34 56 78)"
					/>
					<small>Format: 06 12 34 56 78</small>
				</div>
			</div>
		</div>;
	}



	getQuestion() {
		var currentQuestion;
		if (this.state.step === 1) {
			return this.pensionAlimentaire();
		} else if (this.state.step === 2) {
			return this.permisDeConduire();
		} else if (this.state.step === 3) {
			return this.creationEntreprise();
		} else if (this.state.step === 4) {
			return this.aideAchatVelo();
		} else if (this.state.step === 5 && (this.props.menage?.reductionEligibilityData && this.state.reductionEligibilitySelection !== 'no')) {
			return this.contactInfo();
		}
	}
	render() {


		return <>
			<style>
				{`
					#root .avant-de-terminer .form-group {
						margin-bottom: 20px;
					}

					#root .avant-de-terminer input[type="text"],
					#root .avant-de-terminer input[type="email"],
					#root .avant-de-terminer input[type="tel"],
					#root .avant-de-terminer input[type="number"],
					#root .avant-de-terminer select {
						width: 100%;
						padding: 12px;
						border: 1px solid #ddd;
						border-radius: 8px;
						font-size: 16px;
						margin-top: 8px;
						box-sizing: border-box;
						background:#fff;
						height:auto;
					}

					#root .avant-de-terminer input:focus,
					#root .avant-de-terminer select:focus {
						outline: none;
						border-color: #01205c;
						box-shadow: 0 0 0 2px rgba(1, 32, 92, 0.2);
					}

					#root .avant-de-terminer .contact-form {
						display: grid;
						grid-template-columns: 1fr 1fr;
						gap: 20px;
						margin-top: 20px;
					}

					@media (max-width: 768px) {
						#root .avant-de-terminer .contact-form {
							grid-template-columns: 1fr;
						}
					}

					#root .avant-de-terminer .question.sub-question {
						margin-bottom: 25px;
						padding: 15px;
						background-color: #f9f9f9;
						border-radius: 8px;
					}

					#root .avant-de-terminer .question.sub-question h3 {
						margin-top: 0;
						margin-bottom: 15px;
						color: #01205c;
					}

					#root .avant-de-terminer .euroSign {
						position: absolute;
						right: 12px;
						top: 50%;
						transform: translateY(-50%);
						color: #666;
					}

					#root .avant-de-terminer .input-with-euro {
						position: relative;
					}
				`}
			</style>
			<div className="step-inner-container avant-de-terminer">
				{this.state.step !== 6 && <p className="step-title"><strong>Avant de terminer</strong></p>}
				{this.getQuestion()}
				<FormError errors={this.state.errors} />
				<button onClick={() => (this.checkInputErrors().then(() => this.nextStep()))}> Valider </button>
				<div className="button-container previous">
					<button onClick={this.restart}> Recommencer </button>
				</div>
			</div>
		</>;
	}
}

export default Questionnaire;
